import { App } from 'vue';

import { maska } from 'maska';

import contractProcessStateDirective from '@/modules/performances/directives/contract-process-state.directive';
import { vPurifyHtml } from '@nxtpeople/nxt-styles';
import {
   DateFormatter,
   DateTimeFormatter,
   FontColorContraster,
   LowerCase,
   OutsideClickDirective,
   PhoneFormatter,
   ScrollToDirective,
   UpperCase,
} from '@nxtpeople/nxt-vue-library';
import AddressFormatter from '../directives/address-formatter.directive';
import decimalFormatterDirective from '../directives/decimal-formatter.directive';
import maxValueDirective from '../directives/max-value.directive';
import minValueDirective from '../directives/min-value.directive';
import TimeFormatter from '../directives/time-formatter.directive';

class DirectiveService {
   public setupDirectives(app: App<Element>) {
      app.directive('mask', maska);
      app.directive('scroll-to', ScrollToDirective); // v-scroll-to
      app.directive('address', AddressFormatter); // v-address
      app.directive('phone', PhoneFormatter); // v-phone
      app.directive('outside-click', OutsideClickDirective); // v-outside-click
      app.directive('lowercase', LowerCase); // v-lowercase
      app.directive('uppercase', UpperCase); // v-lowercase
      app.directive('date', DateFormatter); // v-date
      app.directive('date-time', DateTimeFormatter); // v-date-time
      app.directive('time', TimeFormatter); //v-time
      app.directive('decimal', decimalFormatterDirective); // v-decimal
      app.directive('purify', vPurifyHtml); // v-purify
      app.directive('min-value', minValueDirective); // v-min-value
      app.directive('max-value', maxValueDirective); // v-max-value
      app.directive('contract-process-state-color', contractProcessStateDirective); // v-contract-process-state-color
      app.directive('color-contrast', FontColorContraster); // v-color-contrast
   }
}

export default new DirectiveService();
